module.exports = __webpack_public_path__ + "img/Settlement1.46c5d085.png";